import React, { useState } from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  PageListBean,
  PurchaseOrderReceiptPrintRequest,
  PurchaseOrderReceiptSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestVendorListRequest,
  VendorSearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupFabricStyleModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
import CustomTable from "../gui_components/CustomTable.js";
class PurchaseOrderReceiptDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "PurchaseOrder Receipt Details Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new PurchaseOrderReceiptSearchCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      isShowFabricStyleModule: false,
      isShowPurchaseReceiptModule: false,
      moduleForPopup: [],
      inquiryData: null,
      isShowColorLookup: false,
      colorLookupHandler: null,
      showAutoCompleteList: true,
      vendorPageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isCollapsible_open: true,
      isDisableFields: false,
      is3PL: false,
    };
    this.vendorCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor"
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing",
    });
    this.loadPurchaseOrderReceiptList(criteria);
  };
  loadPurchaseOrderReceiptList = (criteria) => {
    if (SecurityAccessManager.PurchaseorderReceiptInquiry_IsAccessible()) {
      ReportService.getPurchaseOrderReceiptDetails(
        criteria,
        this.loadPurchaseOrderReceiptPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPurchaseOrderReceiptPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.purchaseOrderReceiptResult != null
    ) {
      let receivedList = [];
      if (
        !isEmptyArray(
          response.data.purchaseOrderReceiptResult.purchaseOrderReceiptDetails
        )
      ) {
        receivedList =
          response.data.purchaseOrderReceiptResult.purchaseOrderReceiptDetails;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryDataList: receivedList,
        isShowPDFButton: true,
        isShowExcelButton: true,
        isLoading: false,
        isShowClearCriteriaButton: false,
        isCollapsible_open: false,
        isShowColorLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new PurchaseOrderReceiptSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.vendorName = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isShowResetButton: false,
    });
  };
  resetInquiry = () => {
    let criteria = new PurchaseOrderReceiptSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.vendorName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new PurchaseOrderReceiptPrintRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.PurchaseorderReceiptInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generatePurchaseOrderReceiptInquiryReport(
          listRequest,
          this.generatePurchaseOrderReceiptPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.PurchaseorderReceiptInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generatePurchaseOrderReceiptInquiryReport(
          listRequest,
          this.generatePurchaseOrderReceiptPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    }
  };
  generatePurchaseOrderReceiptPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generatePurchaseOrderReceiptPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  
  
  viewPOModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  
  
  viewFabricStyleModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  
  
  viewPurchaseReceiptModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowPurchaseOrderModule: isOpen,
      isShowVendorModule: isOpen,
      isShowFabricStyleModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      moduleForPopup: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  vendorCodeOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.showAutoCompleteVendorList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      let criteria = this.state.criteria;
      criteria.vendorCode = "";
      criteria.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetVendorDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.vendor != null) {
      let vendorData = response.data.vendor;
      if (!isEmpty(vendorData)) {
        criteria.vendorName = vendorData.description;
        criteria.vendorCode = vendorData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetVendorDetail = (vendorCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = vendorCode;
    input.isLoadChildren = true;
    VendorService.readVendor(
      input,
      this.readandsetVendorDetailResponse,
      this.errorCallBack
    );
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack
    );
  }
  readByVendorCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.vendorPageList != null &&
      response.data.vendorPageList.vendors != null
    ) {
      let vendorCodeData = response.data.vendorPageList.vendors;
      let simpleAutoCompleteList = new Array();
      if (vendorCodeData.length > 0 && vendorCodeData != null) {
        vendorCodeData.map((vendorCode) => {
          let simpleItemBean = {
            code: vendorCode.code,
            description: vendorCode.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        vendorPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    this.readandsetVendorDetail(vendorCode);
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
    this.readandsetFabricStyleDetail(fabricStyleCode);
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles != null
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    this.readandsetFabricStyleDetail(e.target.value);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == criteria.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    criteria.fabricStyleColorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricStyleModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item Name" : "FabricStyle Name", "fabricStyleName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPOModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO.Date", "purchaseOrderDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("POReceipt", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("POReceiptDate", "receiptDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedQty", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
   
    
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          fabricLookupHandler={this.state.fabricLookupHandler}
          vendorLookupHandler={this.state.vendorLookupHandler}
          vendorCodeOnChange={this.vendorCodeOnChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          vendorCodeRef={this.vendorCodeRef}
          vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
          displayAutoCompleteVendorList={this.displayAutoCompleteVendorList}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          showHideSecondHeader={this.showHideSecondHeader}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const vendorCodeOnChange = (e) => props.vendorCodeOnChange(e);
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  let criteria = props.criteria;
  let vendorLookupHandler = props.vendorLookupHandler;
  const vendorCodeRef = props.vendorCodeRef;
  let fabricLookupHandler = props.fabricLookupHandler;
  let fabricCodeRef = React.createRef();
  const vendorCodeEnterKeyEventHandler = (e) => {
    props.vendorCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteVendorList = () => {
    props.displayAutoCompleteVendorList();
  };
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const showHideSecondHeader = (e) => {
    if (e.detail === 1) props.showHideSecondHeader();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>Vendor</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={vendorCodeRef}
            name="vendorCode"
            onChange={vendorCodeOnChange}
            value={criteria.vendorCode}
            lookupRequired={true}
            lookupHandler={vendorLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={vendorCodeEnterKeyEventHandler}
            autoCompleteListData={props.vendorPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteVendorList}
            showAutoCompleteList={props.showAutoCompleteVendorList}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="vendorName"
            onChange={onChange}
            value={criteria.vendorName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={true}
            lookupHandler={fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorCode"
              onChange={onFabricColourCodeChange}
              value={criteria.fabricStyleColorCode}
              lookupRequired={props.isShowColorLookup}
              lookupHandler={props.colorLookupHandler}
              enterKeyEventHandler={fabricColourEnterKeyEventHandler}
              autoCompleteListData={
                props.fabricColourPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteFabricColorList}
              showAutoCompleteList={props.showAutoCompleteFabricColorList}
              disabled={!props.isShowColorLookup}
            />
          </Col>
          <Col sm="1">
            <FormLabel> From Date#</FormLabel>
          </Col>
          <Col sm="1">
            <DatePickerComponent_adv
              name="receiptDateFrom"
              value={criteria.receiptDateFrom}
              onChange={onChange}
              disabled={props.isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>To Date</FormLabel>
          </Col>
          <Col sm="1">
            <DatePickerComponent_adv
              name="receiptDateTo"
              onChange={onChange}
              value={criteria.receiptDateTo}
              disabled={props.isDisableFields}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
function PurchaseOrderReceiptDetailsInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <PurchaseOrderReceiptDetails {...props} name="" /> <br />
    </div>
  );
}

export default PurchaseOrderReceiptDetailsInquiry;
